/*global Swiper */
document.querySelectorAll( '.b-latest-news' ).forEach( ( block ) => {

	/////////////////////
	// BLOCK CODE HERE //
	/////////////////////
	const slider = block.querySelector( '.swiper-container' );
	const navPrev = block.querySelector( '.swiper-button-prev' );
	const navNext = block.querySelector( '.swiper-button-next' );

	if ( slider ) {

		new Swiper( slider, {
			direction: "horizontal",
			loop: false,
			speed: 1000,
			slidesPerView: 'auto',
			navigation: {
				nextEl: navNext,
				prevEl: navPrev,
			},
			breakpoints: {
				0: {
					spaceBetween: 10,
				},
				768: {
					spaceBetween: 16,
				},
			}
		} );

	}

} );
